interface SectionHeadingProps {
  eyebrow?: string;
  title: string;
  desc?: string;
  light?: boolean;
}

export default function SectionHeading({ eyebrow, title, desc, light }: SectionHeadingProps) {
  return (
    <div className={`flex flex-col items-start gap-3 sm:flex-row sm:items-end sm:justify-between ${light ? "text-background-50" : "text-foreground-900"}`}>
      <div>
        {eyebrow && (
          <p className={`flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.18em] ${light ? "text-background-200" : "text-primary-500"}`}>
            <span className="h-px w-6 bg-current"></span>
            {eyebrow}
          </p>
        )}
        <h2 className="mt-2 font-display text-2xl leading-snug sm:text-3xl">{title}</h2>
        {desc && (
          <p className={`mt-3 max-w-2xl text-sm leading-relaxed ${light ? "text-background-100" : "text-foreground-500"}`}>{desc}</p>
        )}
      </div>
    </div>
  );
}